import React from 'react';
import { useLocation } from 'react-router';
import cn from 'classnames';

import favorite from 'modules/favorite';
import { Icon, SmartLink } from 'components';
import { ExtendedRouts } from 'app-constants';
import { isFavoritePage } from 'utils';
import favoriteFill from 'assets/svg/favorite-fill.svg';
import './favoriteMobileLink.scss';

const { FavoriteCountAll } = favorite.components;

const FavoriteMobileLink: React.FC<{}> = () => {
    useLocation();

    return (
        <SmartLink
            styleName={cn('container', {
                'is-active': isFavoritePage(),
            })}
            to={ExtendedRouts.FAVORITE_UPCOMING}
        >
            <div styleName="count">
                <FavoriteCountAll />
            </div>
            <Icon styleName="icon" glyph={favoriteFill} />
        </SmartLink>
    );
};

export default FavoriteMobileLink;
